// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._70a3fb{font-size:calc(2em + var(--scale)*3em)}._70a3fb label{font-size:1.2em}", ""]);
// Exports
exports.locals = {
	"progress": "_70a3fb"
};
module.exports = exports;
